export type MarkdownClasses = {
  h1: string;
  h2: string;
  h3: string;
  h4: string;
  h5: string;
  h6: string;
  paragraph: string;
  strong: string;
  em: string;
  link: string;
  blockquote: string;
  codespan: string;
  pre: string;
  ul: string;
  ol: string;
  taskList: string;
  listItem: string;
  checkbox: string;
  table: string;
  th: string;
  td: string;
  hr: string;
  image: string;
};

export const DEFAULT_MARKDOWN_CLASSES: MarkdownClasses = {
  h1: "text-2xl font-bold mt-6 mb-3 text-neutral-900 dark:text-neutral-100",
  h2: "text-xl font-bold mt-5 mb-3 text-neutral-900 dark:text-neutral-100",
  h3: "text-lg font-semibold mt-4 mb-2 text-neutral-900 dark:text-neutral-100",
  h4: "text-base font-semibold mt-4 mb-2 text-neutral-900 dark:text-neutral-100",
  h5: "text-sm font-semibold mt-3 mb-2 text-neutral-900 dark:text-neutral-100",
  h6: "text-sm font-semibold mt-3 mb-2 text-neutral-600 dark:text-neutral-400",
  paragraph: "text-sm leading-relaxed mb-3 text-neutral-800 dark:text-neutral-200 last:mb-0",
  strong: "font-semibold",
  em: "italic",
  link: "text-blue-600 dark:text-blue-400 underline underline-offset-2 hover:text-blue-700 dark:hover:text-blue-300",
  blockquote: "border-l-4 border-neutral-300 dark:border-neutral-700 pl-4 italic text-neutral-600 dark:text-neutral-400 mb-3",
  codespan: "px-1.5 py-0.5 rounded bg-neutral-100 dark:bg-neutral-800 text-neutral-800 dark:text-neutral-200 text-[0.85em] font-mono",
  pre: "bg-neutral-900 dark:bg-neutral-950 text-neutral-100 rounded-lg p-3 mb-3 overflow-x-auto text-sm font-mono",
  ul: "list-disc list-outside pl-5 mb-3 space-y-1 text-sm text-neutral-800 dark:text-neutral-200",
  ol: "list-decimal list-outside pl-5 mb-3 space-y-1 text-sm text-neutral-800 dark:text-neutral-200",
  taskList: "list-none pl-0 mb-3 space-y-1 text-sm text-neutral-800 dark:text-neutral-200",
  listItem: "text-sm leading-relaxed text-neutral-800 dark:text-neutral-200",
  checkbox: "mr-2 align-middle rounded border-neutral-300 dark:border-neutral-600",
  table: "w-full text-sm border-collapse mb-3",
  th: "border border-neutral-200 dark:border-neutral-700 px-3 py-2 font-semibold bg-neutral-50 dark:bg-neutral-800",
  td: "border border-neutral-200 dark:border-neutral-700 px-3 py-2",
  hr: "my-4 border-neutral-200 dark:border-neutral-700",
  image: "max-w-full rounded-lg my-3",
};

export const headingClass = (classes: MarkdownClasses, depth: number): string => classes[`h${depth}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6"] ?? classes.h6;

export const escapeHtml = (value: string) =>
  value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
